module.exports = __webpack_public_path__ + "static/img/LS.07d84b11.svg";